import React, {
  FC,
  ReactNode,
  createContext,
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
} from 'react';

import type { Auth } from '@shared/types';

type AuthData = Auth | undefined;

type AuthContext = [AuthData, Dispatch<SetStateAction<AuthData>>];

export const authContext = createContext<AuthContext>(
  [] as unknown as AuthContext
);

const UserDetailsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [authData, setAuthData] = useState<AuthData>(() => {
    // Инициализируем состояние из localStorage при загрузке
    try {
      const saved = localStorage.getItem('authData');
      // Если мы на странице логина, не загружаем данные из localStorage
      if (window.location.pathname === '/login') {
        console.log('🔍 Skipping authData load on login page');
        return undefined;
      }
      return saved ? JSON.parse(saved) : undefined;
    } catch (error) {
      console.error('Ошибка при загрузке authData из localStorage:', error);
      return undefined;
    }
  });

  // Сохраняем состояние в localStorage при изменении
  useEffect(() => {
    console.log('🔍 AuthData changed:', { authData });
    if (authData) {
      localStorage.setItem('authData', JSON.stringify(authData));
      // Если мы на странице логина и есть authData, перенаправляем на главную
      if (window.location.pathname === '/login') {
        console.log('🔍 Redirecting from login to dashboard...');
        window.location.href = '/';
      }
    } else {
      localStorage.removeItem('authData');
    }
  }, [authData]);

  return (
    <authContext.Provider value={[authData, setAuthData]}>
      {children}
    </authContext.Provider>
  );
};

export default UserDetailsProvider;
